
function formatDateddMMyyyyhhmm(fecha) {

    const d = new Date(fecha);

    try {
        const datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);

        return datestring;

    }
    catch {
        return '';
    }

}

function formatDateyyyyMMdd(fecha) {

    const date = new Date(fecha);

    try {
        const month_names = ["01", "02", "03",
            "04", "05", "06",
            "07", "08", "09",
            "10", "11", "12"];

        const day = date.getDate();
        const month_index = date.getMonth();
        const year = date.getFullYear();

        return year + '-' + month_names[month_index] + '-' + day;
    }
    catch {
        return '';
    }

}


function formatDateddMMMyyyy(fecha) {

    try {
        let date = new Date(fecha)
        //date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

        const month_names = ["Ene", "Feb", "Mar",
            "Abr", "May", "Jun",
            "Jul", "Ago", "Sep",
            "Oct", "Nov", "Dic"];

        const day = date.getDate();
        const month_index = date.getMonth();
        const year = date.getFullYear();

        return day + '-' + month_names[month_index] + '-' + year;

    }
    catch (ex) {
        return '';
    }
}

export { formatDateddMMyyyyhhmm, formatDateyyyyMMdd, formatDateddMMMyyyy }